// @ts-strict-ignore
import React, { useMemo } from 'react';
import { Text } from '@usealloy/component-library';
import {
  selectDataRoutes,
  selectFocusedAction,
  selectServiceRoutingCategoryNameInEditing,
  selectServices,
} from 'flow/store/redux/selectors';

import { useAppSelector } from '~/store/reduxHooks';
import {
  StyledDataRoutingFormContainer,
  StyledLeftColumnContainer,
  StyledRightColumnContainer,
  StyledSpacer,
} from './styles';
import { getIncomingDataRoutingCategories, getOutgoingDataRoutingCategories } from '~/dashboard/views/workflows/service/dataRoutes';
import RoutingCategory from './RoutingCategory';

export default function DataRoutingTab() {
  const dataRoutes = useAppSelector(selectDataRoutes);
  const services = useAppSelector(selectServices);

  const serviceCategoryNameInEdition = useAppSelector(selectServiceRoutingCategoryNameInEditing);
  const focusedAction = useAppSelector(selectFocusedAction);

  const availableIncomingCategories = useMemo(() => (
    getIncomingDataRoutingCategories({
      action: focusedAction,
      dataRoutes,
      services,
    })
  ), [focusedAction, dataRoutes, services]);

  const availableOutgoingCategories = useMemo(() => (
    getOutgoingDataRoutingCategories({
      action: focusedAction,
      dataRoutes,
      services,
    })
  ), [focusedAction, dataRoutes, services]);

  return (
    <StyledDataRoutingFormContainer>
      <StyledLeftColumnContainer>
        <Text
          as="h3"
          size={3}
          weight={400}
        >
          Incoming
        </Text>
        {availableIncomingCategories?.length
          ? availableIncomingCategories.map(dataRoutingCategory => (
            <RoutingCategory
              key={dataRoutingCategory.category.category_id}
              mode="incoming"
              dataRoutingCategory={dataRoutingCategory}
              isEditing={serviceCategoryNameInEdition === dataRoutingCategory.category.name}
            />
          ))
          : (
            <Text
              as="span"
              size={2}
              weight={400}
            >
              There are currently no services in the Workflow which are eligible to route data from.
            </Text>
          )}
      </StyledLeftColumnContainer>
      <StyledRightColumnContainer>
        <Text
          as="h3"
          size={3}
          weight={400}
        >
          Outgoing
        </Text>
        {availableOutgoingCategories?.length
          ? availableOutgoingCategories.map(dataRoutingCategory => (
            <RoutingCategory
              key={dataRoutingCategory.category.category_id}
              mode="outgoing"
              dataRoutingCategory={dataRoutingCategory}
              isEditing={serviceCategoryNameInEdition === dataRoutingCategory.category.name}
            />
          ))
          : (
            <Text
              as="span"
              size={2}
              weight={400}
            >
              There are currently no services in the Workflow which are eligible to route data to.
            </Text>
          )}
      </StyledRightColumnContainer>
      <StyledSpacer />
    </StyledDataRoutingFormContainer>
  );
}

